module.exports = __webpack_public_path__ + "img/icon-pdf-white.ff8942b7.png";